<template>
  <span v-if="status" class="msg-ticks" :class="`msg-ticks--${status}`" :title="title" role="img" :aria-label="title">
    <svg v-if="status === 'failed'" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10" /><line x1="12" y1="7" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
    <svg v-else-if="status === 'sent'" width="14" height="11" viewBox="0 0 16 11" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="1.5 6 5 9.5 12.5 1.5" />
    </svg>
    <svg v-else width="18" height="11" viewBox="0 0 20 11" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="1.5 6 5 9.5 12.5 1.5" /><polyline points="8 8.5 9 9.5 16.5 1.5" />
    </svg>
  </span>
</template>

<script setup lang="ts">
// Tiques do WhatsApp numa mensagem nossa: ✓ enviada, ✓✓ entregue, ✓✓ azul lida, ⚠ não entregue (motivo no
// título). Vem de "StatusMensagem" (SignalR) e de deliveryStatus na busca. Sem status = não saiu pelo WhatsApp
// (nota interna, histórico antigo) — não mostra nada.
import { computed } from 'vue'
import type { DeliveryStatus } from '@/services/wootdashConversations'

const props = defineProps<{ status?: DeliveryStatus | null; error?: string | null }>()

const title = computed(() => ({
  sent: 'Enviada',
  delivered: 'Entregue',
  read: 'Lida',
  failed: `Não entregue${props.error ? ` — ${props.error}` : ''}`,
}[props.status ?? 'sent']))
</script>

<style scoped>
/* "msg-ticks", não "mt": .mt é o contêiner da página Métricas (assets/metricas.css, global) e esticava os tiques. */
.msg-ticks { display: inline-flex; align-items: center; margin-left: 4px; vertical-align: middle; line-height: 0; opacity: .85; }
.msg-ticks--sent, .msg-ticks--delivered { color: currentColor; }
.msg-ticks--read { color: #53bdeb; opacity: 1; }
.msg-ticks--failed { color: #fbbf24; opacity: 1; cursor: help; }
</style>
